import type { Messages } from './en'

export const nl: Messages = {
  'common.back': 'Terug',
  'common.opensInNewTab': 'opent in een nieuw tabblad',
  'omnidek.openPortal': 'Omnidek-portaal openen',
  'auth.signedOut': 'U bent afgemeld.',
  'auth.login': 'Aanmelden',

  'language.label': 'Taal selecteren',

  'nav.home': 'Home',
  'nav.calendar': 'Agenda',
  'nav.training': 'Training',
  'nav.profile': 'Profiel',
  'nav.primary': 'Hoofdnavigatie',

  'splash.welcome': 'Welkom',
  'splash.loading': 'EDF SuperApp laden',

  // Home — prospect-variant (begroeting, toegankelijkheid carrousel, contactkaart).
  'home.greeting': 'Welkom terug',
  'home.editName': 'Naam bewerken',
  'home.assetId': 'Asset ID',
  'home.carousel.label': 'Uitgelicht',
  'home.carousel.prev': 'Vorige',
  'home.carousel.next': 'Volgende',
  'home.carousel.goToSlide': 'Ga naar dia {number}',
  'home.carousel.slide1.alt': 'Uitgelicht 1',
  'home.carousel.slide2.alt': 'Uitgelicht 2',
  'home.carousel.slide3.alt': 'Uitgelicht 3',
  'home.contact.title': 'Neem contact op',
  'home.contact.body':
    'Heb je een vraag of hulp nodig? Ons team staat voor je klaar — neem contact op en we reageren snel.',
  'home.contact.cta': 'Bericht sturen',
  'home.feature.title': 'Privékapitaal voor inclusieve economische groei',
  'home.feature.cta': 'Aanvraag voltooien',
  'home.apply.cta': 'AANVRAAG VOLTOOIEN',
  'home.feature.imageAlt': 'Lachende ouders met hun jonge zoon op de schouders van zijn vader',

  'applicationStatus.title': 'Aanvraagstatus',
  'applicationStatus.overview': 'Overzicht',
  'applicationStatus.status.completed': 'Voltooid',
  'applicationStatus.status.underReview': 'In beoordeling',
  'applicationStatus.status.draft': 'Concept',
  'applicationStatus.status.actionRequired': 'Actie vereist',
  'applicationStatus.status.inProgress': 'In uitvoering',
  'applicationStatus.card.nextSteps': 'Volgende stappen',
  'applicationStatus.card.viewDetails': 'Details bekijken',
  'applicationStatus.card.continue': 'Doorgaan',

  'applicationOfInterest.title': 'Interesseaanvraag',

  'application.title': 'KYC-aanvraag',
  'application.loading': 'KYC-aanvraag laden...',
  'upload.sectionNotOpen': 'Deze sectie is nog niet open voor uploads.',
  'upload.docAlreadyPassed': 'Dit document is al goedgekeurd — een nieuwe upload is niet nodig.',
  'upload.documentUnderReview':
    'Dit document is al in behandeling. Als u per ongeluk het verkeerde bestand heeft geüpload, neem dan contact op met support via support@economicdevelopmentfund.com.',
  'upload.invalidFileType':
    'Alleen PDF- en afbeeldingsbestanden (PNG, JPEG, WebP, GIF, BMP) worden ondersteund voor weergave in de browser. Upload een ondersteund formaat.',
  'upload.fileTooLarge': 'Bestandsgrootte overschrijdt de limiet van 10 MB. Upload een kleiner bestand.',
  'upload.budgetNotEditable': 'Dit budget is in beoordeling of al goedgekeurd.',
  'upload.invoiceNotConfirmed': 'De factuurupload kon niet worden bevestigd. Probeer het opnieuw.',
  'upload.invoiceOpenFailed': 'De factuur kon niet worden geopend. Probeer het opnieuw.',

  // KYC step gating on /apply — what shows instead of (or over) the form.
  'kyc.submitting': 'Uw aanvraag wordt ingediend...',
  'kyc.waiting.title': 'Uw documenten worden beoordeeld',
  'kyc.waiting.body':
    'U hebt alles geüpload wat we voorlopig nodig hebben. Ons team beoordeelt uw documenten — we laten het weten zodra er nieuws is of een volgende stap klaarstaat.',
  'kyc.complete.title': 'Uw KYC is afgerond',
  'kyc.complete.body':
    'Al uw documenten zijn beoordeeld en goedgekeurd. Er is niets meer te uploaden.',
  'kyc.failed.title': 'Een document vraagt om uw aandacht',
  'kyc.failed.intro':
    'Het volgende document is beoordeeld en kon niet worden geaccepteerd. Upload een vervanging.',
  'kyc.failed.noReason': 'Er is geen reden opgegeven. Upload het document opnieuw.',
  'kyc.failed.continue': 'Doorgaan',
  'kyc.submitted.dialog.title': 'Inzending ontvangen',
  'kyc.submitted.dialog.body':
    'Uw KYC-aanvraag en documenten zijn succesvol ingediend en worden momenteel beoordeeld door ons team.',
  'kyc.submitted.dialog.viewStatus': 'Aanvraagstatus bekijken',
  'kyc.submitted.dialog.done': 'Klaar',
  'kyc.panel.action.status': 'Aanvraagstatus bekijken',
  'kyc.panel.action.home': 'Terug naar startpagina',

  'profile.logout': 'Uitloggen',

  'pwa.install.banner.title': 'Download de EDF-app',
  'pwa.install.banner.body': 'Sneller toegang en een snelkoppeling op je beginscherm',
  'pwa.install.cta': 'Installeren',
  'pwa.install.dismiss': 'Sluiten',

  'stageBar.important.prefix': 'Belangrijk',
  'stageBar.apply.label': 'Voltooi je aanvraag om verder te gaan',

  'nextStep.dialog.title': 'Volgende stappen',
  'nextStep.dialog.nda.body':
    'Bedankt voor je interesse in de diensten van The Economic Development Fund. Om gevolg te geven aan je interesse, vul de geheimhoudingsverklaring (NDA) in, onderteken deze en dien deze in.',
  'nextStep.dialog.kyc.body':
    'Bedankt voor je interesse in de diensten van The Economic Development Fund. Om verder te gaan met je aanvraag, vul het KYC-formulier (Know Your Customer) in en dien dit in.',
  'nextStep.dialog.close': 'Sluiten',
  'nextStep.dialog.next': 'Volgende',
}
